module.exports = __webpack_public_path__ + "static/img/configure.def6de8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/student-home/configure.png
// module id = FVyl
// module chunks = 32